import { Component, ComponentFactoryResolver, NgZone, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AccessManagerResourceActionType } from 'src/app/auth/accessManager/accessManager.models';
import { AccessManagerService } from 'src/app/auth/accessManager/accessManager.service';
import { FeaturePermissionsService } from 'src/app/auth/raas/featurePermissions.service';
import { ImpersonationService } from 'src/app/auth/apigee/impersonation.service';
import { INamedClass } from 'src/app/common/iNamedClass';
import { LoadManagerService } from 'src/app/common/loadingOverlay/loadManager.service';
import { LoggerService } from 'src/app/common/logging/logger.service';
import { OfficeSelectorService } from 'src/app/common/officeSelector/officeSelector.service';
import { DashboardCfgService } from 'src/app/dashboard/dashboardCfg.service';
import { StaticDashboardDefinitionComponent } from 'src/app/dashboard/staticDashboardDefinition.component';
import { DashboardMenuTabSelectorService } from 'src/app/dashboardCommon/services/dashboardMenuTabSelector.service';
import { DashboardRecruitmentSubsService } from '../../services/dashboard-recruitmen-subs.service';
import { ApigeeService } from 'src/app/auth/apigee/apigee.service';

export class DataMock {
  public BucketId: string;
  public BucketName: string;
  public Office: string;
  public Need: string;
  public EnBucket: string;
  public H6: string;
  public Applicants: string;
  public Pet: string;
  public PetWeek: string;
}

@Component({
    selector: 'dashboard-recruitment-center',
    templateUrl: './dashboard-recruitment-center.component.html',
    styleUrls: ['./dashboard-recruitment-center.component.css'],
    providers: [LoadManagerService],
    standalone: false
})
export class DashboardRecruitmentCenterComponent implements OnInit, INamedClass {

  public getClassName() { return "DashboardRecruitmentCenterComponent"; }

  private mBusy: boolean;
  private mIsProfessionals: boolean = false;
  private mLoadStatusUpdatedSubscription: Subscription;
  private saveTextActionSubscription: Subscription;

  public textAction: string = "¡Buen trabajo!";

  @ViewChild('dashboardItemContainer', { read: ViewContainerRef }) private itemContainer: ViewContainerRef;

  private staticDashboardDefinition: StaticDashboardDefinitionComponent;

  public get isProfessionals(): boolean {
    return this.officeSelectorService.selectedOffice && !this.officeSelectorService.selectedOffice.isTEA && this.mIsProfessionals;
  }

  public get isUPayroll(): boolean {
    return this.officeSelectorService.selectedOffice && this.officeSelectorService.selectedOffice.isUPayroll;
  }

  public get isFundation(): boolean {
    return this.officeSelectorService.selectedOffice && this.officeSelectorService.selectedOffice.isFundation;
  }

  public get selectedOfficeIsRecruitment(): boolean {
    return this.officeSelectorService.selectedOffice && this.officeSelectorService.selectedOffice.regionId == "70"
  };

  public get showDasboardRecruitment(): boolean {
    return this.dashboardCfgService.getCfg().showDasboardRecruitment == 1
  };

  private mAccessGranted: Promise<boolean>;
  private mSelectedTab: number;
  private mSelectedTabChangedSubscription: Subscription;

  public get selectedTab(): number { return this.mSelectedTab; }

  private mSelectedOfficeUpdatedSubscription: Subscription;
  public showKpis: boolean = true;

  private routerEventsSubscription: Subscription;

  constructor(private dashboardCfgService: DashboardCfgService,
    private factoryResolver: ComponentFactoryResolver,
    private zone: NgZone, private router: Router,
    private logger: LoggerService,
    private apigeeService: ApigeeService,
    private impersonationService: ImpersonationService,
    private accessManagerService: AccessManagerService,
    private loadManagerService: LoadManagerService,
    private selectedTabService: DashboardMenuTabSelectorService,
    private officeSelectorService: OfficeSelectorService,
    private featurePermissionsService: FeaturePermissionsService,
    private dashboardRecruitmentSubsService: DashboardRecruitmentSubsService) { }

  public async ngOnInit() {

    this.mLoadStatusUpdatedSubscription = this.loadManagerService.loadStatusUpdated.subscribe((value) => {
      this.zone.run(() => this.mBusy = value);
    });

    this.mSelectedTabChangedSubscription = this.selectedTabService.selectedTabChanged.subscribe((index) => this.mSelectedTab = index);
    this.mSelectedTab = this.selectedTabService.selectedTab;

    this.mSelectedOfficeUpdatedSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe((value) => {
      this.zone.run(() => {
        this.showKpis = value ? value.isTEA : false;

        if ((this.mIsProfessionals && !(value ? value.isTEA : false)) || this.isFundation) {
          this.zone.run(() => this.router.navigate(['home']));
        }
        else if (this.isUPayroll) {
          this.zone.run(() => this.router.navigate(['dashboard/direct']));
        }
        else if (this.selectedOfficeIsRecruitment && this.showDasboardRecruitment) {
          this.zone.run(() => this.router.navigate(['dashboard/recruitment']));
        }
        else {
          this.zone.run(() => this.router.navigate(['dashboard']));
        }
      });
    });

    this.saveTextActionSubscription = this.dashboardRecruitmentSubsService.listenLoadTextAction().subscribe((response) => {
      this.textAction = response;
    }, error => console.error(error));

    this.loadManagerService.incLoadRequest();
  }

  public async ngAfterViewInit(): Promise<void> {
    try {
      this.mAccessGranted = new Promise<boolean>(async (resolve, reject) => {
        try {
          let apigee = this.apigeeService;

          if (apigee.apiToken == null && (apigee.googleAuthToken == null || apigee.googleDirectoryToken == null)) {
            throw new Error("No credentials present");
          }
          else {
            await this.featurePermissionsService.professionalsEnabled().then(result => this.zone.run(() => this.mIsProfessionals = result));

            let permissions = await this.accessManagerService.getResourcePermissions(this.dashboardCfgService.getCfg().resourceId);
            if (permissions && permissions.getResourceAction(AccessManagerResourceActionType.ApplicationAccess)) {
              resolve(true);
            } else {
              resolve(false);
            }
          }
        } catch (error) {
          reject(error);
        }
      });

      if (!await this.mAccessGranted) {
        this.zone.run(() => this.router.navigate(['home']));
      } else {
        setTimeout(() => {
          if (this.officeSelectorService.selectedOffice && !this.officeSelectorService.selectedOffice.isTEA) {
            if (this.mIsProfessionals || this.isFundation) this.zone.run(() => this.router.navigate(['home']));
            else this.zone.run(() => this.showKpis = false);
          }
          else if (this.officeSelectorService.selectedOffice && this.isUPayroll) {
            this.zone.run(() => this.router.navigate(['dashboard/direct']));
          }
          else if (this.selectedOfficeIsRecruitment && this.showDasboardRecruitment) {
            this.zone.run(() => this.router.navigate(['dashboard/recruitment']));
          } else {
            this.zone.run(() => this.showKpis = true);
          }
        }, 250);
      }

    } catch (error) {
      this.zone.run(() => this.router.navigate(['login']));
    }
    finally {
      this.loadManagerService.decLoadRequest();
    }


    try {
      if (await this.mAccessGranted) {
        this.logger.traceActivity("Acceso a Dashboard");
        await this.loadDashboardItems();
      }
    } catch (error) { }
  }

  private async loadDashboardItems(): Promise<void> {
    try {
      this.loadManagerService.incLoadRequest();
      let factory = this.factoryResolver.resolveComponentFactory(StaticDashboardDefinitionComponent);
      this.staticDashboardDefinition = this.itemContainer.createComponent(factory).instance;
    } catch (error) {
      throw error;
    } finally {
      this.loadManagerService.decLoadRequest();
    }
  }

  public ngOnDestroy(): void {
    if (this.routerEventsSubscription) this.routerEventsSubscription.unsubscribe();
    if (this.mSelectedOfficeUpdatedSubscription) this.mSelectedOfficeUpdatedSubscription.unsubscribe();
    if (this.mLoadStatusUpdatedSubscription) this.mLoadStatusUpdatedSubscription.unsubscribe();
    if (this.mSelectedTabChangedSubscription) this.mSelectedTabChangedSubscription.unsubscribe();
    if (this.saveTextActionSubscription) this.saveTextActionSubscription.unsubscribe();
  }

  public get busy(): boolean {
    return this.mBusy;
  }

  public get impersonationEnabled(): boolean {
    return this.impersonationService.canImpersonate;
  }

  public get callToActionBucketPercentageHostVisible(): boolean {
    return true;
  }

  public get callToActionBucketFillOutHostVisible(): boolean {
    return true;
  }

  public get callToActionPriorityHostVisible(): boolean {
    return true;
  }

  public get dashboardOwner(): string {
    return this.impersonationService.isImpersonating ? this.impersonationService.getUserDisplayName() : "";
  }

}
